import React from "react";
import lmiaImage from "../assets/images/lmia.png";
import HowWorkCard from "../component/cards/HowWorkCard";
export default function HowItWorks() {
  return (
    <>
      <div className="container px-5 md:px-20 m-auto " id="howtowork">
        <div className="text-center py-5 space-y-4">
          <h1 className="text-5xl font-bold  text-black">How It Works</h1>
          <p className="text-black text-lg text-normal leading-8 w-full md:w-3/5 m-auto">
            LMIA.LTD offers a user-friendly interface to navigate through our
            comprehensive database of LMIA's issued by ESDC. Here's a
            step-by-step guide on how to effectively utilize our search filters:
          </p>
        </div>
		<div className="flex items-center  justify-center">
				<img src={lmiaImage} alt="" className="rounded-lg  dark:bg-gray-500 aspect-video 	w-full md:w-1/2" />
			</div>
          <div className="grid grid-cols-1 md:grid-cols-2 px-2 justify-center items-center py-8  gap-x-6   rounded-sm sm:p-8  dark:bg-violet-400 dark:text-gray-900">
            <HowWorkCard
              text="Year: Select one or multiple years from 2014 onwards to refine your search. By
			default, the last three years are selected."
            />
            <HowWorkCard
              text="Quarter: Choose one or multiple quarters (Q1 through Q4) to narrow down your
			search further. All quarters are selected by default."
            />

            <HowWorkCard
              text="Program Stream: Filter by program stream to find relevant LMIA's. All program
			streams are selected by default."
            />
            <HowWorkCard
              text="Province: Select one or multiple provinces to focus your search on specific regions.
			All provinces are selected by default."
            />
            <HowWorkCard
              text="City: Cities listed here are dynamically related to the selected provinces. Choose one
			or multiple cities or leave it as default to search across all cities."
            />
            <HowWorkCard
              text="Status: Choose between APPROVED, DENIED, or both to filter LMIA's based on
			their status. APPROVED is selected by default.
			"
            />
            <HowWorkCard
              text="NOC: Narrow down your search by selecting one or multiple National Occupational
			Classification (NOC) codes. All NOCs are selected by default.
			"
            />
            <HowWorkCard
              text="Search Field: Once your desired filters are selected, use the search field to enter
			keywords or phrases to find specific information within the filtered dataset.
			"
            />
            <HowWorkCard
              text="Our intuitive interface ensures that you can effortlessly navigate through the vast array
			of LMIA information to find exactly what you need.
			"
            />
          </div>
       
       
      </div>
    </>
  );
}
